export const CHANGE_PASSWORD_FORM_NAME = 'changePassword'
export const CHANGE_PASSWORD_REDUCER_NAME = 'changePassword'

export const CHANGE_PASSWORD_ERROR_CODES = {
  OLD_PASSWORD_INVALID: 10212131116,
  OLD_PASSWORD_NOT_VALID: 10212131113,
}
